export interface LinkGroup {
  title: string;
  links: { text: string; url: string }[];
}

export const PRODUCT_LINKS: LinkGroup = {
  title: 'Product',
  links: [
    { text: 'Features', url: '/product' },
    { text: 'Reviews', url: '/reviews' },
    { text: 'Plans and Pricing', url: '/pricing' },
  ],
};

export const MIGHTY_PRO_LINKS: LinkGroup = {
  title: 'Mighty Pro',
  links: [
    { text: 'Pro Features', url: '/pro' },
    { text: 'Implementation Services', url: '/pro/services' },
    { text: 'Migration Services', url: '/migration' },
    { text: 'Pro Case Studies', url: '/case-studies?plan=pro' },
  ],
};

// TODO (MKT-10072): Remove this on page release
export const RESOURCES_LINKS_WITHOUT_PARTNERS_PROGRAM: LinkGroup = {
  title: 'Resources',
  links: [
    { text: 'Podcast', url: 'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2?si=3810e7488d5f46aa' },
    { text: 'Masterclass', url: '/peoplemagic' },
    { text: 'Case Studies', url: '/case-studies' },
    { text: 'Setup Training', url: 'https://community.mightynetworks.com/spaces/12898937/content' },
    { text: 'New Feature Training', url: 'https://community.mightynetworks.com/spaces/12890102/list' },
    { text: 'Weekly Sessions', url: 'https://community.mightynetworks.com/events' },
    { text: 'Help Center', url: 'https://faq.mightynetworks.com/' },
    { text: 'Encyclopedia', url: '/encyclopedia' },
    { text: 'Overview', url: '/resources' },
  ],
};

export const RESOURCES_LINKS: LinkGroup = {
  title: 'Resources',
  links: [
    { text: 'Podcast', url: 'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2?si=3810e7488d5f46aa' },
    { text: 'Masterclass', url: '/peoplemagic' },
    { text: 'Case Studies', url: '/case-studies' },
    { text: 'Setup Training', url: 'https://community.mightynetworks.com/spaces/12898937/content' },
    { text: 'New Feature Training', url: 'https://community.mightynetworks.com/spaces/12890102/list' },
    { text: 'Weekly Sessions', url: 'https://community.mightynetworks.com/events' },
    { text: 'Help Center', url: 'https://faq.mightynetworks.com/' },
    { text: 'Encyclopedia', url: '/encyclopedia' },
    { text: 'Partner Program', url: '/partner-program' },
    { text: 'Overview', url: '/resources' },
  ],
};

export const COMPANY_LINKS: LinkGroup = {
  title: 'Company',
  links: [
    { text: 'Careers', url: '/careers' },
    { text: 'Trust Center', url: 'https://trust.mightynetworks.com/' },
    { text: 'Terms of Service', url: '/terms-of-use' },
    { text: 'Privacy Policy', url: '/privacy-policy' },
  ],
};

export const COMPARISON_LINKS: LinkGroup = {
  title: 'Comparison',
  links: [
    { text: 'Mighty vs. Circle', url: '/resources/circle-vs-mighty-networks' },
    { text: 'Mighty vs. Kajabi', url: '/resources/mighty-networks-vs-kajabi' },
    { text: 'Mighty vs. Skool', url: '/resources/mighty-networks-vs-skool' },
  ],
};
